<div class="loading-background">
	<div class="content">
		@if(showText) {
			<div>Loading</div>
		}
		<div class="loader"></div>
	</div>
</div>